import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  editItem,
  fetchDataAllCompany,
  fetchId,
  fetchLicense,
  generateLicense,
  resetData,
  selectDataAllCompany,
  selectDataLicense,
  selectId,
  selectLoading,
} from "./licenseSlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  checkEmptyFields,
  showDialog,
  paramsMasterAll,
  setOptionsMaster,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { Marker } from "../../utility/Marker";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import CurrencyInput from "react-currency-input-field";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Mengimpor ikon dari react-icons

import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { fetchRole, selectRole } from "../role/roleSlice";
import MultiSelectAll from "../../utility/MultiSelectAll";
import { fetchParam, selectDataParam } from "../param/paramSlice";

export const LicenseGenerate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const user = useSelector(selectUser);
  const dataId = useSelector(selectId);
  const dataParam = useSelector(selectDataParam);
  const dataLicese = useSelector(selectDataLicense);

  const { id } = useParams();

  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [company, setCompany] = useState([]);
  const [qty, setQty] = useState("");
  const [days, setDays] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [optionsParam, setOptionParam] = useState([]);
  const [optionsLicense, setOptionLicense] = useState([]);

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(resetData());

      const params = {
        user_id: id,
      };
      await dispatch(
        fetchParam({ ...paramsMasterAll, param_group_code: "DAYS" })
      );
      await dispatch(fetchLicense({ ...paramsMasterAll }));

      if (id !== undefined) {
        await CallApi(params, fetchId, dispatch);
      }
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataParam.length > 0) {
      setOptionsMaster(dataParam, setOptionParam, "param_id", "param_code");
    }
  }, [dataParam]);

  useEffect(() => {
    if (dataId) {
    }
  }, [dataId]);

  const handleSave = async () => {
    const fields = [
      { value: qty, message: "input qty", valid: true },
      { value: days, message: "input Month", valid: true },
    ];

    const errorMessage = checkEmptyFields(fields);
    if (errorMessage) {
      return showDialog(errorMessage);
    }

    const params = {
      user_allocation: qty,
      valid_months: days,
    };

    try {
      const response =
        id === undefined
          ? await dispatch(generateLicense(params))
          : await dispatch(editItem(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        await history.goBack();
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleChangeDays = createChangeHandler(setDays);

  const handleCompanyChange = (selectedOptions) => {
    if (selectedOptions) {
      setCompany(
        selectedOptions.map(function(selectedOptions) {
          if (selectedOptions) {
            return selectedOptions["value"];
          }
        })
      );
    } else {
      setCompany([]);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined ? "Generate License" : "Generate License"}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>

            <Button
              className="btn btn-danger"
              onClick={(e) => {
                handleSave();
              }}
            >
              Save
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Company</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={
                        id === undefined
                          ? user.company_name
                          : dataId?.company_name
                      }
                      disabled
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      License Quantity<b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={qty}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (
                          value === "" ||
                          (!isNaN(value) && Number(value) > 0)
                        ) {
                          setQty(value);
                        }
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}

              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Month <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={days}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (
                          value === "" ||
                          (!isNaN(value) && Number(value) > 0)
                        ) {
                          setDays(value);
                        }
                      }}
                    />
                    {/* <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={optionsParam}
                      value={getValueStatus(days, optionsParam)}
                      placeholder="Select ..."
                      onChange={handleChangeDays}
                      isClearable={true}
                    /> */}
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>
        </CardBody>
      </Card>
    </>
  );
};
